var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-bottom-sheet',{attrs:{"persistent":"","value":_vm.value,"max-width":"500px"}},[_c('v-card',{staticClass:"rounded-0 rounded-t-xl py-6 pt-8 px-6"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }